// extracted by mini-css-extract-plugin
export default {"actions":"_86a99bd4b14a33ef","action":"b76574a4425d29bd","checkbox":"_902388a0552623ca","categoryNameCell":"e388a36f5b343f82"};